import { AuthContext, useAuthProvider } from '../../hooks/useAuth';

type Props = { children: React.ReactNode };

export function AuthProvider({ children }: Props) {
  const auth = useAuthProvider();
  return <AuthContext.Provider value={auth}>{children}</AuthContext.Provider>;
}
